<template>
	<Common>
		<template #half>
			<div class="card flex">
				<div class="box f1">
					<div class="t0">
						WELCOME
					</div>
					<div class="t1">
						It only takes a few seconds
						<div class="t11">&nbsp;& by login, you can:</div>
					</div>
					<ul>
						<li>Genarate your own prompts & imapges;</li>
						<li>Save your favorite promts & images;</li>
						<li>Like to the best work;</li>
						<li>Ontime online Support;And much more!</li>
					</ul>
					<div class="googleBtn">
						<div
							id="g_id_onload"
							data-client_id="293705446569-aab2s9qtaue9022bvu4ddb45kgdpp0ml.apps.googleusercontent.com"
							data-context="signin"
							data-ux_mode="popup"
							data-callback="handleToken"
							data-nonce=""
							data-auto_prompt="false"></div>

						<div
							class="g_id_signin"
							data-type="standard"
							data-shape="rectangular"
							data-theme="outline"
							data-text="signin_with"
							data-size="large"
							data-logo_alignment="left"></div>
					</div>
					<div class="t2">
						By creating an account, you agree to our
						<span
							class="t22"
							@click="go('/terms-of-services')">
							Terms of Service
						</span>
						and
						<span
							class="t23"
							@click="go('/privacy-policy')">
							Privacy Policy
						</span>
					</div>
				</div>
			</div>
		</template>
	</Common>
</template>

<script>
import mixin from './mixin'

export default {
	mixins: [mixin],
}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
	.card {
		// width: 75vw;
		margin: auto;
	}
}
.card {
	height: rem(1080);
	background: url('~@/assets/login-bg.webp') no-repeat center / cover;
}
.box {
	padding: rem(200) rem(154) rem(50);
	display: flex;
	flex-direction: column;
	align-items: center;
}
.t0 {
	color: #fff;
	text-align: center;
	font-family: 'Bakbak One';
	font-size: rem(80);
	font-style: italic;
	font-weight: 400;
	// line-height: rem(40); /* 100% */
}
.t00 {
	display: inline;
	background: linear-gradient(96deg, #3CCA7C 0%, #28C5C2 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	font-family: 'Bakbak One';
	font-size: rem(40);
	font-style: normal;
	font-weight: 400;
	line-height: rem(40);
}
.t1 {
	display: flex;
	margin: rem(40);
	color: #fff;
	text-align: center;
	font-family: Roboto;
	font-size: rem(20);
	font-style: normal;
	font-weight: 600;
	line-height: rem(20); /* 100% */
}
.t11 {
	background: linear-gradient(90deg, #47f67c 64.35%, #11aade 88.02%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	font-family: Roboto;
	font-size: rem(20);
	font-style: normal;
	font-weight: 600;
	line-height: rem(20);
}
ul {
	list-style-type: none;
	margin-bottom: rem(100);
	li {
		color: #fff;
		font-family: Roboto;
		font-size: rem(20);
		font-style: normal;
		font-weight: 400;
		line-height: rem(40); /* 200% */
		text-align: center;
	}
}
ul li::marker {
	list-style-type: disc !important;
	color: #657ef7 !important;
}
.t2 {
	white-space: nowrap;
	color: #fff;
	text-align: center;
	font-family: Roboto;
	font-size: rem(16);
	font-style: normal;
	font-weight: 400;
	line-height: rem(40); /* 250% */
	margin-top: rem(100);
}
.t22 {
	background: linear-gradient(96deg, #3CCA7C 0%, #28C5C2 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	font-family: Roboto;
	font-size: rem(16);
	font-style: normal;
	font-weight: 400;
	line-height: rem(40);
}
.t23 {
	background: linear-gradient(96deg, #3CCA7C 0%, #28C5C2 100%);
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	font-family: Roboto;
	font-size: rem(16);
	font-style: normal;
	font-weight: 400;
	line-height: rem(40);
}
</style>
